module.exports = __webpack_public_path__ + "static/media/virusLogo.7564e0cc.png";